import type { SxProps, Theme } from '@mui/material';
import { theme } from '@/lib/theme';

// Shared styling for the icon-button triggers on the search header controls
// (Filter / Display options / Export). `active` is the open (and, for the
// export control, authenticated-and-open) state that paints the primary fill.
export function searchControlIconButtonSx(active: boolean): SxProps<Theme> {
  return {
    height: { xs: 32, md: 36 },
    width: { xs: 32, md: 36 },
    borderRadius: '8px',
    borderColor: active ? 'primary.main' : undefined,
    backgroundColor: active ? 'primary.main' : undefined,
    '&:hover': {
      backgroundColor: active ? 'primary.dark' : undefined,
    },
    '& svg': { color: active ? 'primary.contrastText' : undefined },
  };
}

// Shared styling for the standard 36px menu rows inside those control menus.
export const searchControlMenuItemSx: SxProps<Theme> = {
  height: '36px',
  minHeight: '36px',
  py: 0,
  paddingLeft: '8px !important',
  fontSize: '12px',
};

export const searchControlMenuDivider = `1px solid ${theme.palette.divider}`;

// Shared `slotProps.list` styling for control menus that contain compact
// toggle rows (My Herd, EBV display toggles, etc.).
export const searchControlToggleListSx: SxProps<Theme> = {
  width: 'min(calc(100vw - 48px), 280px)',
  li: {
    p: 0,
    fontSize: '12px',
    label: {
      m: 0,
      pl: '8px',
      height: '36px',
      width: '100%',
      fontSize: '12px',
    },
    '& .MuiFormControlLabel-label': { fontSize: '12px' },
    '.MuiSwitch-root': {
      position: 'absolute',
      right: '8px',
      transform: 'scale(0.8)',
      transformOrigin: 'top right',
    },
  },
};
